import { useState } from "react";
import { v4 as uuid } from "uuid";

import { ResearchSection } from "#modules/similarPart/view/ResearchSection";
import { useCreatePartToSearch } from "#modules/similarPart/view/useCreatePartToSearch";
import { PageLayout } from "#shared/layouts/PageLayout";
import { FilterQuery } from "shared";

export const SearchPage = () => {
  const [filtersParams, setFiltersParams] = useState<FilterQuery>(defaultFiltersParams);

  const { isPending, progress, uploadFile } = useCreatePartToSearch();

  return (
    <PageLayout title={`Rechercher une pièce`} titleIcon="shapeTriangle">
      <ResearchSection
        progress={progress}
        uploadFile={uploadFile}
        onChangeFilters={setFiltersParams}
        filtersParams={filtersParams}
        is3dSearchLoading={isPending}
      />
    </PageLayout>
  );
};

export const defaultFiltersParams: FilterQuery = {
  filterGroup: {
    conditional: "AND",
    expressions: [
      {
        property: "materialGrade",
        operator: "EQUAL",
        value: null,
        id: uuid(),
      },
    ],
  },
};
